export const formatPrice = (price) => {
  if (!price) {
    return 0;
  }
  if (price === 0) {
    return 'Ücretsiz';
  }
  return `₺${parseFloat(price).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};

export const formatPriceWithoutSymbol = (price) => {
  if (!price) {
    return 0;
  }
  if (price === 0) {
    return 'Ücretsiz';
  }
  return parseFloat(price).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}; 